module.exports = __webpack_public_path__ + "img/rings-wedding.0a2ec5ee.svg";